export const FILTER_NAMES = {
  BRAND_DRILLDOWN: 'brand-drilldown',
  BRAND_DRILLTHROUGH_DEST: 'brand-drillthrough-dest',
  BRAND_DRILLTHROUGH_SOURCE: 'brand-drillthrough-source',
  BRAND_DRILLTHROUGH: 'brand-drillthrough',
  BRAND: 'brand',
  CATEGORY_DRILLDOWN: 'category-drilldown',
  CATEGORY_DRILLTHROUGH: 'category-drillthrough',
  CATEGORY: 'category',
  CATEGORYSINGLE: 'categorySingle',
  COEFFICIENTSELECTOR: 'coefficientSelector',
  COMPACT_VIEW_BRAND: 'compact-view-brand',
  COMPACT_VIEW_CATEGORY: 'compact-view-category',
  COMPACT_VIEW_PPG: 'compact-view-ppg',
  COMPACT_VIEW_SIZEGROUP: 'compact-view-sizeGroup',
  COMPACT_VIEW_SUBBRAND: 'compact-view-subBrand',
  COMPBRAND: 'compBrand',
  DATE: 'date',
  DATEHIER: 'dateHier',
  DATEPOST: 'datePost',
  DATEPREV: 'datePrev',
  DATEZOOM: 'dateZoom',
  DEPENDENTVAR: 'dependentVar',
  MANUFACTURER: 'manufacturer',
  MARKET_DRILLDOWN: 'market-drilldown',
  MARKET: 'market',
  MARKETLEVEL: 'marketLevel',
  MARKETMULTI: 'marketMulti',
  MEASUREHIER: 'measureHier',
  METACATEGORY: 'metaCategory',
  PERIODLENGTH: 'periodLength',
  PPG_DRILLDOWN: 'ppg-drilldown',
  PPG_DRILLTHROUGH_DEST: 'ppg-drillthrough-dest',
  PPG_DRILLTHROUGH_SOURCE: 'ppg-drillthrough-source',
  PPG_DRILLTHROUGH: 'ppg-drillthrough',
  PPG: 'ppg',
  PROD: 'prod',
  PRODUCTHIER_DRILLDOWN: 'productHier-drilldown',
  PRODUCTHIER: 'productHier',
  PRODUCTHIER1: 'productHier1',
  SCENARIOPLANNERCOEFFVERSION: 'scenarioPlannerCoeffVersion', // Also known Model Update Date
  SCENARIOPLANNERFIELD: 'scenarioPlannerField', // User input fields
  SCENARIOPLANNERFIELDMAIN: 'scenarioPlannerFieldMain', // Main Elasticity fields
  SCENARIOPLANNERFIELDCROSS: 'scenarioPlannerFieldCross', // Cross Elasticity fields
  SCENARIOPLANNERFIELDSTARTING: 'scenarioPlannerFieldStarting', // Starting metrics fields

  SCENARIOPLANNERINPUTYPE: 'scenarioPlannerInputType',
  SCENARIOPLANNERNUMBEROFWEEKS: 'scenarioPlannerNumberOfWeeks',
  SCENARIOPLANNERPRODHIER: 'scenarioPlannerProductHier',
  SCENARIOPLANNERWEEKSFROM: 'scenarioPlannerWeeksFrom',
  SCENARIOPLANNERID: 'scenarioPlannerId',
  SIZEGROUP_DRILLDOWN: 'sizeGroup-drilldown',
  SIZEGROUP_DRILLTHROUGH_DEST: 'sizeGroup-drillthrough-dest',
  SIZEGROUP_DRILLTHROUGH_SOURCE: 'sizeGroup-drillthrough-source',
  SIZEGROUP_DRILLTHROUGH: 'sizeGroup-drillthrough',
  SIZEGROUP: 'sizeGroup',
  SUBBRAND_DRILLDOWN: 'subBrand-drilldown',
  SUBBRAND_DRILLTHROUGH_DEST: 'subBrand-drillthrough-dest',
  SUBBRAND_DRILLTHROUGH_SOURCE: 'subBrand-drillthrough-source',
  SUBBRAND_DRILLTHROUGH: 'subBrand-drillthrough',
  SUBBRAND: 'subBrand',
  SUBCATEGORY_DRILLTHROUGH: 'subCategory-drillthrough',
  SUBCATEGORY: 'subCategory',
  SUBPPG: 'subPpg',
  UPC: 'upc',
  VARIABLE: 'variable',
  VARIABLECOMPBRAND_DRILLDOWN: 'variableCompBrand-drilldown',
  VARIABLECOMPBRAND: 'variableCompBrand',
  VARIABLEGROUP: 'variableGroup',
};

export const ENCODED_FILTER_SEL_PAR = 'e';
